import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';
import { TokenExpireService } from 'src/app/services/token-expire.service';
import { CustomLoaderService } from '../../services/custom-loader.service';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { FormBuilder, FormGroup } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-data-upload-status',
  templateUrl: './data-upload-status.component.html',
  styleUrls: ['./data-upload-status.component.scss']
})
export class DataUploadStatusComponent implements OnInit {
  IsSubscribed = environment.IsSubscribed;
  FilterForm: FormGroup;
  CompanyName = environment.CompayName;
  AutoUploadData: any = [];
  IsMobile: boolean = false;
  constructor(
    private fb: FormBuilder,
    private Loader: CustomLoaderService,
    private Logout: TokenExpireService,
    private router: Router,
    private route: ActivatedRoute,
    private EncrdecrService: EncrdecrService,
    private Report: ReportService
  ) {
    this.FilterForm = fb.group({
      // CheckFilter2 :["false"],
      // CheckFilter1 :["false"],
      CheckFilter: ['1']
      // CheckFilter3 :["true"],
    });
  }
  ngAfterViewInit() {}
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  ngOnInit() {
    this.SetViewPort(window.innerWidth);
    $(document).ready(function () {
      $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(
          imgURL,
          function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
          },
          'xml'
        );
      });
    });
    this.BindAutoUploadStatus(0);
    // setTimeout(() => {
    //   this.Loader.hide();
    // }, 1000);
  }

  BindAutoUploadStatus(providerid: number) {
    let result = [];
    $('#AutoUploadReportTable').DataTable().clear();
    $('#AutoUploadReportTable').DataTable().destroy();
    this.Report.GetAutoUploadReport(providerid).subscribe((data) => {
      result = data.ArrayOfResponse;
      if (result != null) {
        this.AutoUploadData = result;
        if ($.fn.DataTable.isDataTable('#AutoUploadReportTable')) {
          $('#AutoUploadReportTable').DataTable().clear();
          $('#AutoUploadReportTable').DataTable().destroy();
          $('#AutoUploadReportTable').DataTable({
            oLanguage: {
              sEmptyTable: 'No Record Found.'
            },
            pageLength: 10,
            bLengthChange: false,

            bPaginate: true,
            info: true,
            searching: true,
            ordering: false,
            language: {
              paginate: {
                next: '&#8594;', // or '→'
                previous: '&#8592;' // or '←'
              }
            }
          });
        } else {
          $(document).ready(() => {
            $('#AutoUploadReportTable').DataTable({
              oLanguage: {
                sEmptyTable: 'No Record Found.'
              },
              pageLength: 10,
              bLengthChange: false,

              bPaginate: true,
              info: true,
              searching: true,
              ordering: false,
              language: {
                paginate: {
                  next: '&#8594;', // or '→'
                  previous: '&#8592;' // or '←'
                }
              }
            });
          });
        }
      }
    });
  }
}
